import axios from 'axios';
//import Vue from 'vue'
export default {

    getFaq(faqType){
        return axios.get('/api/faq/get/list', { params: {faqType:faqType} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error)})
    },

}